<template>
  <div class="slide zoom" v-parallax-fit="parallax">
    <div class="maze"></div>
    <div class="hand"></div>
  </div>
</template>

<script>
export default {
  name: 'slide14_1',
  mounted() {
    const evidence = {
      items: [
        {
          image: '/themes/rise-theme/dist/images/estate/character-view/vanessa/evidence/7a.jpg',
          url: 'https://www.gsb.stanford.edu/insights/how-banks-undermined-federal-foreclosure-assistance',
          link_title: {
			'en': 'How Banks Undermined Federal Foreclosure Assistance',
			'es': 'Cómo los bancos socavaron la asistencia federal para ejecuciones hipotecarias'
		  }
        },
        {
          image: '/themes/rise-theme/dist/images/estate/character-view/vanessa/evidence/7b.jpg',
          url: 'https://www.journals.uchicago.edu/doi/abs/10.1086/691701',
          link_title: {
			'en': 'Policy Intervention in Debt Renegotiation',
			'es': 'Política de intervención en la renegociación de la deuda'
		  }
        },
      ],
      text: {
		'en': 'According to a 2017 study, "many big banks and mortgage-servicing companies apparently weren’t up to the job, even if it was in their financial interest. A significant share of those companies lacked the organizational capacity to renegotiate large numbers of loans and opted not to make internal changes that would have enabled them to take advantage of the program," resulting in millions of preventable foreclosures.<br /><b>From: Policy Intervention in Debt Renegotiation: Evidence from the Home Affordable Modification Program<br />by Sumit Agarwal, Gene Amromin, Itzhak Ben-David, Souphala Chomsisengphat, Tomasz Piskorski, Amit Seru Journal of Political Economy June 2017 Vol. 125 Issue 3 Pages 654-712</b>',
		'es': 'Según un estudio de 2017, "muchos grandes bancos y compañías de servicios hipotecarios aparentemente no estaban a la altura del trabajo, incluso si era en su interés financiero. Una parte significativa de esas compañías carecía de la capacidad organizativa para renegociar una gran cantidad de préstamos y optaron por no realizar cambios internos que les habrían permitido aprovechar el programa", lo que resultó en millones de ejecuciones hipotecarias prevenibles.<br /><b>De: Intervención de políticas en la renegociación de deudas: Evidencia del programa de modificación Home Affordable<br />por Sumit Agarwal, Gene Amromin, Itzhak Ben-David, Souphala Chomsisengphat, Tomasz Piskorski, Amit Seru Revista de Economía Política Junio de 2017 vol. 125 Número 3 Páginas 654-712</b>'
	  }
    };

    const text = {
		'en': 'Vanessa\'s nightmare in trying to secure a loan modification was not unique to her. The Home Affordable Modification Program (HAMP), whose aim was to prevent foreclosure by offering incentives to banks to modify loans, could have helped 70% more homeowners had bank lenders been better organized.',
		'es': 'La pesadilla de Vanessa al tratar de asegurar una modificación de préstamo no era exclusiva de ella. El Programa de Modificación de Vivienda Asequible (HAMP), cuyo objetivo era evitar la ejecución hipotecaria ofreciendo incentivos a los bancos para modificar los préstamos, podría haber ayudado a un 70 % más de propietarios si los prestamistas bancarios hubieran estado mejor organizados.'
	};
    this.mutationObserver = new window.MutationObserver(mutationList => {
      mutationList.forEach( mutation => {
        if(mutation.target.style.transform == 'translateY(0px) translateX(0px) rotateZ(0deg)') {
          this.$evidence.value = JSON.stringify(evidence);
          this.$readMore.value = text;
        }
      });
    });

    this.mutationObserver.observe(document.querySelector('#slide14_1'), {
      attributes: true,
      attributeFilter: ['style']
    });
  },
  unmounted() {
    this.mutationObserver.disconnect();
  },
  data() {
    return {
		mutationObserver: null,
      parallax: [
        {
          start: 11300,
          end: 11800,
          fromStyle: { transform: 'translateY(-1800px) translateX(-900px) rotateZ(-15deg)' },
          toStyle: { transform: 'translateY(0px) translateX(0px) rotateZ(0deg)' },
          easing: 'linear'
        },
        {
          start: 15000,
          end: 15500,
          fromStyle: { transform: 'translateY(-1px) translateX(0px) rotateZ(0deg)' },
          toStyle: { transform: 'translateY(-1800px) translateX(-900px) rotateZ(-15deg)' },
          easing: 'linear'
        },
      ],
    };
  }
}
</script>

<style lang="scss" scoped>
.slide {
    position: fixed;
    transition: 0.5s;
    z-index: 5;
    left: calc(50% - 421px);
    //top: 100px;
    top: calc(50% - 480px);
    @media(max-width: 600px) {
      left: calc(50% - 391px);
      top: calc(50% - 260px);
    }

    .maze {
      position: absolute;
      transform-origin: center;
      background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/14_PaperMaze_1.png');
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      width: 589px;
      height: 660px;
      left: 0;
      top: 136px;
      @media(max-width: 600px) {
        width: 197px;
        left: 200px;
        top: calc(50% - 382px);
      }
    }

    .hand {
      position: absolute;
      transform-origin: center;
      background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/14_Hand_1.png');
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      width: 310px;
      height: 1190px;
      left: 14px;
      top: -709px;
      transform: rotateZ(-11deg);
      animation: 'scaling 1s infinite alternate';
      @media(max-width: 600px) {
        top: calc(50% - 1170px);
      }
    }
}
@keyframes scaling {
  0% {
      transform: scale(1.0) rotateZ(-11deg);
  }
  100% {
      transform: scale(1.1) rotateZ(-11deg);
  }
}
</style>
